import { Route, RouteComponentProps } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';
import { CollectionPage } from './CollectionPage';

const SentryEnhancedRoute = withSentryRouting(Route);

interface IProps extends RouteComponentProps<void> {}

export const CollectionsRoot = (props: IProps) => {
  const { match } = props;

  const renderCollectionsRoot = () => <h1>Select collection</h1>;

  return (
    <>
      <SentryEnhancedRoute path={match.url} exact render={renderCollectionsRoot} />
      <SentryEnhancedRoute path="/collections/:name/:id?" component={CollectionPage} />
    </>
  );
};
